import validateForm from '../../../../utils/validateForm';
import { cloneObject } from '../../../../utils';

function validate(dataForm) {
    let clonedDataForm = cloneObject(dataForm);

    let allFormsValid = true;

    clonedDataForm = clonedDataForm.map((dependente) => {
        const { validatedForm, isValid } = validateForm(dependente);

        if (!isValid) {
            allFormsValid = false;
        }

        return { ...validatedForm };
    });

    return { validatedForm: clonedDataForm, isValid: allFormsValid };
}

export default validate;
